export enum IoniconsFilled {
  doc = 'document-text',
  attach = 'attach',
  settings = 'settings',
  tags = 'pricetags',
  tag = 'pricetag',
  users = 'people',
  user = 'person',
  filter = 'funnel',
  time = 'time',
  copy = 'copy',
  boxes = 'file-tray-stacked',
  support = 'help-buoy',
  camera = 'camera',
  archive = 'archive',
  home = 'home',
  userCircle = 'person-circle',
  lock = 'lock-closed',
  lockOpen = 'lock-open',
  upload = 'cloud-upload',
  storage = 'cloud',
  plus = 'add',
  download = 'download',
  infoCircle = 'information-circle',
  edit = 'create',
  calendarCheck = 'calendar',
  ia = 'extension-puzzle',
  check = 'checkmark',
  close = 'close',
  refresh = 'refresh',
  warning = 'warning',
  mail = 'mail',
  key = 'key',
  comment = 'chatbubble-ellipses',
  commentSquare = 'chatbox',
  search = 'search',
  menu = 'menu',
  open = 'open',
  expand = 'chevron-forward',
  collapse = 'chevron-back',
  save = 'save',
  star = 'star',
  sync = 'sync',
  file = 'document',
  folder = 'folder',
  trash = 'trash',
  build = 'build',
  bug = 'bug',
  arrowUp = 'chevron-up',
  arrowDown = 'chevron-down',
  caretDown = 'caret-down',
  caretRight = 'caret-forward',
  caretLeft = 'caret-back',
  send = 'send',
  like = 'thumbs-up',
  tab = 'code-working',
  list = 'list',
  checkbox = 'checkbox',
  checkboxUnchecked = 'square-outline',
  square = 'square',
  fitContainer = 'expand',
  contract = 'contract',
  radiobutton = 'checkmark-circle',
  radioUnchecked = 'ellipse-outline',
  ellipse = 'ellipse',
  report = 'megaphone',
}
